<template>
  <v-container>
    <cumulus-edit-dialog
      ref="editOperatingDay"
      v-model="dialogEditOperatingDay"
      icon="$edit"
      :max-width="700"
      :title="$t('operating_day')"
      :loading="loading"
      can-delete
      persistent
      @save="saveOperatingDay"
      @remove="removeOperatingDay"
      @escape="closeDialogEditOperatingDay"
    >
      <template v-slot:editform>
        <edit-operating-day
          :operating-day="edited_item"
        />
      </template>
    </cumulus-edit-dialog>
    <v-card class="mb-0 rounded-0">
      <v-card-title class="ma-0">
        <operating-day-user-informations />
        <v-btn
          class="mr-4"
          color="primary"
          @click="setToday"
        >
          {{ $t('today') }}
        </v-btn>
        <div>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
        <span v-if="$refs.calendar" class="mx-2 text-h3 mb-4 mt-4">{{ $refs.calendar.title }}</span>
        <v-spacer />
        <v-menu
          bottom
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="grey darken-2"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
            >
              <span>{{ $t(typeToLabel[type]) }}</span>
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'day'">
              <v-list-item-title>{{ $t('day') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
              <v-list-item-title>{{ $t('week') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'month'">
              <v-list-item-title> {{ $t('month') }} </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <tooltip-btn
          v-if="editor"
          v-shortkey.once="['f2']"
          custom-class="pl-2"
          color="primary"
          :title="$t('new_operating_day')"
          dynamic
          icon="mdi-plus-circle"
          :text="false"
          :tooltip="'new_operating_day'"
          @click="showDialogEditOperatingDay({})"
          @shortkey="showDialogEditOperatingDay({})"
        />
      </v-card-title>
      <v-card-text>
        <v-sheet height="700">
          <v-calendar
            ref="calendar"
            v-model="focus"
            locale="hu"
            color="primary"
            :events="events"
            :type="type"
            :event-height="60"
            :weekdays="weekdays"
            @click:date="showDialogEditOperatingDay"
            @change="updateRange"
          >
            <template v-slot:event="{ event }">
              <v-col class="text-center text-truncate" style="padding: 2px">
                {{ $t('fields.coordinator_id') + ': ' + event.operating_day.coordinator.name }}
              </v-col>
              <v-col class="text-center" style="padding: 1px">
                <v-avatar
                  color="teal"
                  size="24"
                >
                  <span class="white--text text-h5">{{ event.operating_day.users.length }}</span>
                </v-avatar>

                <operating-day-informations
                  v-if="profile.can['operating-day-info']"
                  :operating-day="event.operating_day"
                />
                <tooltip-btn
                  v-if="profile.can['operating-day-edit']"
                  color="white"
                  icon="$edit"
                  tooltip="tooltip_edit"
                  @click="showDialogEditOperatingDay(event)"
                />
                <tooltip-btn
                  v-if="event.operating_day.users.filter(u => u.id === profile.user_id).length === 0"
                  color="white"
                  icon="$subscribe"
                  tooltip="tooltip_operating_day_subscribe"
                  @click="Subscribe(event.operating_day); updateRange(date_interval)"
                />
                <tooltip-btn
                  v-else
                  color="red"
                  icon="$unsubscribe"
                  tooltip="tooltip_operating_day_unsubscribe"
                  @click="Unsubscribe(event.operating_day); updateRange(date_interval)"
                />
              </v-col>
            </template>
          </v-calendar>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { call, get, sync } from 'vuex-pathify'
  import moment from 'moment'
  import EditOperatingDay from '@/layouts/default/edit/OperatingDay'
  import OperatingDayInformations from '@/layouts/default/infos/OperatingDayInfo'
  import CumulusEditDialog from '@/components/EditDialog'
  import OperatingDayUserInformations from '@/layouts/default/infos/OperatingDayUserInfo'

  export default {
    components: {
      OperatingDayUserInformations,
      CumulusEditDialog,
      OperatingDayInformations,
      EditOperatingDay,
    },
    data: () => ({
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'month',
        week: 'week',
        day: 'day',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      formTitle: 'operating_days',
      edited_item: {},
      date_interval: {
        start: null,
        end: null,
      },
      dialogEditOperatingDay: false,
    }),
    computed: {
      profile: get('auth/profile'),
      loading: sync('app/loading'),
      editor () { return this.profile.can['operating-day-edit'] },
    },
    watch: {
      activeTab: {
        handler () {
          this.updateRange(this.date_interval)
          // this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.type = this.$vuetify.breakpoint.mobile ? 'day' : 'month'
    },
    methods: {
      getOperatingDays: call('operatingDay/search'),
      Update: call('operatingDay/update'),
      Insert: call('operatingDay/insert'),
      Delete: call('operatingDay/delete'),
      Subscribe: call('operatingDay/subscribe'),
      Unsubscribe: call('operatingDay/unsubscribe'),
      async updateRange ({ start, end }) {
        const events = []
        this.events = []
        this.date_interval = {
          start: start,
          end: end,
        }

        await this.getOperatingDays({
          start: new Date(`${start.date}T00:00:00`),
          end: new Date(`${end.date}T23:59:59`),
        }).then(response => {
          const organizationId = this.profile.organization.id
          response.map(function (event, key) {
            const start = moment(event.start)
            let color = '#00E676'
            if (event.coordinator_sr || event.winch_operator_sr) {
              color = '#FF1744'
            } else if (event.instructor_igt1_sr || event.instructor_igp_sr) {
              color = '#FF9100'
            }
            if ([138, 144].includes(organizationId)) {
              if (event.coordinator && (event.instructor_igt1 || event.instructor_igt2 || event.instructor_igp) && (event.winch_operator || event.tow_pilot)) {
                color = '#00E676'
              } else if (event.coordinator && (event.instructor_igt1 || event.instructor_igt2 || event.instructor_igp) && !(event.winch_operator || event.tow_pilot)) {
                color = '#ffae17'
              } else if (event.coordinator && !(event.instructor_igt1 || event.instructor_igt2 || event.instructor_igp) && (event.winch_operator || event.tow_pilot)) {
                color = '#e8f000'
              } else if (event.coordinator && (event.instructor_igt1 || event.instructor_igt2 || event.instructor_igp) && !(event.winch_operator || event.tow_pilot)) {
                color = '#FF1744'
              } else {
                color = '#FF1744'
              }
            }

            if (event.comment) {
              if (event.comment.includes('#set_to_black')) {
                color = '#000000'
              }
            }

            events.push({
              id: event.id,
              start: start.toDate(),
              color: color,
              operating_day: event,
            })
          })
        }).catch(e => {
          console.log(e)
        })
        this.events = events
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        // return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },

      showDialogEditOperatingDay (item) {
        console.log(item)
        if (item.operating_day) {
          this.edited_item = Object.assign({}, item.operating_day)
        } else {
          this.edited_item = { start: item.date }
        }
        this.edited_item.start = moment(this.edited_item.start).format('YYYY-MM-DD')
        this.dialogEditOperatingDay = true
      },
      closeDialogEditOperatingDay () {
        this.dialogEditOperatingDay = false
        this.$nextTick(() => {
          this.updateRange(this.date_interval)
          this.edited_item = {}
        })
      },
      async saveOperatingDay () {
        console.log(this.edited_item)
        if (this.edited_item.id > -1) {
          this.Update(
            this.edited_item,
          ).then(response => {
            this.edited_item = response
            this.closeDialogEditOperatingDay()
          }).catch(e => {
            this.$refs.editOperatingDay.setErrors(e)
            // console.log(e)
          })
        } else {
          this.Insert(
            this.edited_item,
          ).then(response => {
            this.edited_item = response
            this.closeDialogEditOperatingDay()
          }).catch(e => {
            this.$refs.editOperatingDay.setErrors(e)
            // console.log(e)
          })
        }
        console.log(this.edited_item)
      },
      async removeOperatingDay () {
        try {
          this.loading = true
          await this.Delete(
            { id: this.edited_item.id },
          ).then(response => {
            this.closeDialogEditOperatingDay()
          }).catch(e => {
            this.loading = false
            this.$refs.editOperatingDay.setErrors(e)
            console.log(e)
          })
        } catch (e) {
          /* this.$buefy.notification.open({
            message: this.$t('app.error.general'),
            type: 'is-danger',
          }) */
        }
      },
    },
  }
</script>

<style lang="sass">
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside
  background-color: #dbdbdb

#calendar
  .v-calendar-weekly__day:last-child,
  .v-calendar-weekly__head-weekday:last-child
    border-right: none
  .v-calendar-weekly__week:last-child .v-calendar-weekly__day
    border-bottom: none

.v-event
  width: 100% !important
  height: calc(100% - 44px) !important
  padding-top: 10px

</style>
